<template>
  <sistema>
    <container :isModal="false" :loading="stateLoading || !stateReady">
      <template v-slot:header>
        <h3>Cadastro de Novo Cliente</h3>
      </template>
      <template v-slot:body>
        <form @submit.prevent="submitSave">
          <fieldset :disabled="stateLoading">
            <div class="p-formgrid p-grid">
              <div>
                <input-with-label
                  label="Nome do cliente"
                  :required="true"
                  v-slot="l"
                >
                  <InputText
                    v-model="entity.nome"
                    :id="l.id"
                    :required="l.required"
                    maxlength="250"
                    v-focus
                  />
                </input-with-label>
              </div>
              <div>
                <input-with-label label="Usuário" :required="true" v-slot="l">
                  <InputText
                    v-model="entity.login"
                    :id="l.id"
                    :required="l.required"
                    maxlength="250"
                  />
                </input-with-label>
              </div>
              <div>
                <input-with-label label="Senha" :required="true" v-slot="l">
                  <Password
                    v-model="entity.senha"
                    :id="l.id"
                    :required="l.required"
                    maxlength="250"
                  />
                </input-with-label>
              </div>
              <div>
                <input-with-label
                  label="Confirmar Senha"
                  :required="true"
                  v-slot="l"
                >
                  <Password
                    v-model="confirmacaoSenha"
                    :id="l.id"
                    :required="l.required"
                    maxlength="250"
                    :feedback="false"
                  />
                </input-with-label>
              </div>
              <div>
                <Button type="submit" class="p-button-rounded" label="Salvar" />
              </div>
            </div>
          </fieldset>
        </form>
      </template>
    </container>
  </sistema>
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  Ref,
  onMounted
} from "vue";
import {
  TenantPayload,
  useTenantService
} from "../../modules/business/cliente/tenantBusiness";
import { useRouter } from "vue-router";
import { useToast } from "../../modules/message";

interface TenantCadastroState {
  entity: TenantPayload;
  stateReady: boolean;
  confirmacaoSenha: string;
  loadings: Array<Ref<boolean>>;
}

export default defineComponent({
  setup() {
    const router = useRouter();
    const state = reactive<TenantCadastroState>({
      entity: useTenantService().safeTenant(),
      stateReady: false,
      confirmacaoSenha: "",
      loadings: []
    });

    const stateLoading = computed(() => {
      return state.loadings.length !== 0;
    });

    const submitSave = () => {
      if (state.confirmacaoSenha !== state.entity.senha) {
        useToast().warning("Os campos de confirmação e senha não sao iguais!");
        return;
      }

      const {
        saveNewTenant,
        loading: loadingCadastro,
        data: dataCadastro
      } = useTenantService();

      state.loadings.push(loadingCadastro);
      saveNewTenant(state.entity)
        .then(() => {
          useToast().success("Cliente criado com sucesso");
          const id = dataCadastro.value;
          state.loadings.splice(state.loadings.indexOf(loadingCadastro), 1);
          router.push({ name: "root-cliente-edit", params: { idCliente: id } });
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loadingCadastro), 1);
        });
    };

    onMounted(async () => {
      state.stateReady = true;
    });

    return {
      submitSave,
      stateLoading,
      ...toRefs(state)
    };
  },
  components: {}
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
